<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* font styling */
@font-face {
  font-family: "gotham";
  src: url("./fonts/Gotham-Book.otf");
}

@font-face {
  font-family: "gothamLight";
  src: url("./fonts/Gotham-Light.otf");
}

@font-face {
  font-family: "gothamThin";
  src: url("./fonts/Gotham-Thin.otf");
}

@font-face {
  font-family: "gothamMedium";
  src: url("./fonts/Gotham-Medium.otf");
}

@font-face {
  font-family: "gothamUltra";
  src: url("./fonts/Gotham-Ultra.otf");
}

@font-face {
  font-family: "gothamNarrowBlack";
  src: url("./fonts/GothamNarrow-Black.otf");
}

@font-face {
  font-family: "Lato";
  src: url("./fonts/Lato-Regular.ttf");
}



:root {
  --gtl-orange: #f26526;
  --gtl-green: #059ca6;
  --black: #1A0B04;
  --grey: rgba(0, 0, 0, 0.4);
  --gothamLight: "gothamLight", sans-serif;
  --gotham: "gotham", sans-serif;
  --gothamMedium: "gothamMedium", sans-serif;
  --deep-grey: rgba(15, 61, 71, 0.9);
  --deeper-grey: #0f3d47;
  --light-grey: #e5e5e5;
  --Lato: "Lato", sans-serif;
}
h1,
.h1 {
  font-size: 3.3125rem;
  line-height: 1.15em;
}

h2, .h2 {
  font-size: 2.25rem;
  line-height: 1.5em;
}

h3, .h3 {
  font-size: 1.5625rem;
  line-height: 1.4em;
}

h4, .h4 {
  font-size: 1.125rem;
  line-height: 1.5em;
}

h5,
.h5 {
  font-size: 1.0625rem;
  line-height: 1.55em;
  margin-bottom: 15px;
}

h6,
.h6 {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 500;
}
h1,
h2,
h3,
.h1,
.h2,
.h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: var(--gothamMedium);

}

h4,
h5,
h6,
.h4,
.h5,
.h6 {
  margin-top: 10px;
  margin-bottom: 10px;
  font-family: var(--gotham);

}

p{
  font-family: var(--Lato);

}

body {
  font-family: var(--gotham);
}
</style>
